// Catalog-image plan handoff. The lifestyle tool call has to carry
// creativeType, planId, and capUsd or the server cap never runs.
// The model supplies the rest of the args; these three are filled
// from the plan studio link.

import type { ChatContext, Message } from './types';

const LIFESTYLE_TOOL = 'catalog.generateLifestyleImages';

export function catalogImagePlan(context: ChatContext | null | undefined): Record<string, unknown> | null {
  if (!context || context.creativeType !== 'catalog-image') return null;
  const extra: Record<string, unknown> = { creativeType: 'catalog-image' };
  if (context.planId) extra.planId = context.planId;
  if (typeof context.capUsd === 'number' && Number.isFinite(context.capUsd) && context.capUsd >= 0) {
    extra.capUsd = context.capUsd;
  }
  return extra;
}

export function applyCatalogImagePlan(messages: Message[], context: ChatContext | null | undefined): Message[] {
  const extra = catalogImagePlan(context);
  if (!extra) return messages;
  return messages.map((message) => {
    if (message.role !== 'assistant' || !message.tool_calls?.length) return message;
    let changed = false;
    const tool_calls = message.tool_calls.map((call) => {
      const name = call.function.name.replace(/__/g, '.');
      if (name !== LIFESTYLE_TOOL) return call;
      let args: Record<string, unknown> = {};
      try {
        const parsed = JSON.parse(call.function.arguments || '{}') as unknown;
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) args = parsed as Record<string, unknown>;
      } catch { /* keep the plan fields anyway */ }
      changed = true;
      return {
        ...call,
        function: { ...call.function, arguments: JSON.stringify({ ...args, ...extra }) }
      };
    });
    return changed ? { ...message, tool_calls } : message;
  });
}
